import { ClipLoader } from 'react-spinners';
import { useFetchVisibleAccountsQuery } from '@/slices/account-api-slice.ts';
import AccountsList from '../account/accounts-list.tsx';

const OrganizationAccountsList = ({ organizationKey }: { organizationKey: string }) => {
  const { data, isLoading } = useFetchVisibleAccountsQuery({ organizationKey: organizationKey });

  return (
    <>
      <div className='text-center'>
        <ClipLoader color='blue' loading={isLoading} />
      </div>
      {!isLoading && <AccountsList accounts={data ?? []} />}
    </>
  );
};

export default OrganizationAccountsList;
